import { ResourceType } from '@lmt/shared-types';
import { getDateTimeInterval } from '@lmt/unicorn-shared/app/helpers/date-helper';
import { patientResourceType, ResourceSettings } from './types';

export const resourceSettings: ResourceSettings = {
  [patientResourceType]: { isMultiSelect: false, isEmbedded: true },
  [ResourceType[ResourceType.Doctors]]: { isMultiSelect: false },
  [ResourceType[ResourceType.Places]]: { isMultiSelect: false },
  [ResourceType[ResourceType.SpecialConditions]]: { isMultiSelect: true },
};

export function getCreateFormDefaultValues(data: {
  visitId?: number | null;
  selectedInterval?: Interval;
  caseId?: number;
  visitTypeId?: number | null;
}) {
  return {
    patient: null,
    visitTypeId: data.visitTypeId ?? null,
    priorityContactType: null,
    waitingList: false,
    priority: null,
    alertPatient: null,
    note: '',
    resources: {},
    takenTimeSlots: [],
    caseId: data.caseId ?? null,
    dateTimeInterval: data.visitId
      ? // if visit is being edited its interval will be loaded later
        {
          startDate: null,
          startTimeInMills: null,
          endDate: null,
          endTimeInMills: null,
        }
      : getDateTimeInterval(data.selectedInterval),
    attendingDoctorId: null,
    statusId: null,
  };
}
